import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Sticky from 'react-stickynode';

import Image from '../Image';

import useWindowWidth from '../../hooks/useWindowWidth';

import { SliderWrapper } from '../ProductGallery/ProductGalleryStyles';
import { StyledDivInner, GalleryCenteringWrapper } from './CustomCollectionGalleryStyles';

var CustomCollectionGallery = function CustomCollectionGallery(props) {
  var windowWidth = useWindowWidth();

  return React.createElement(
    'div',
    { className: 'StickyContainer' },
    React.createElement(
      Sticky,
      {
        top: 120,
        bottomBoundary: '.StickyContainer',
        enabled: windowWidth >= 1000
      },
      React.createElement(
        StyledDivInner,
        null,
        React.createElement(
          GalleryCenteringWrapper,
          null,
          React.createElement(
            SliderWrapper,
            null,
            React.createElement(
              Slider,
              {
                className: 'ProductSlider',
                infinite: true,
                slidesToShow: 1,
                rows: 1,
                slidesToScroll: 1,
                dots: true
              },
              React.createElement(Image, { src: props.collectionImage, alt: props.title }),
              props.customCollectionImages && props.customCollectionImages.map(function (src) {
                return React.createElement(Image, { key: src, src: src, alt: '' });
              })
            )
          )
        )
      )
    )
  );
};

CustomCollectionGallery.propTypes = {
  title: PropTypes.string,
  collectionImage: PropTypes.string,
  customCollectionImages: PropTypes.array
};

export default CustomCollectionGallery;